import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Box, Button } from "@chakra-ui/react";
 
const RichTextEditor = ({editorHtml, setEditorHtml, isReadOnly} : any) => {
 
  return (
    <Box>
          <ReactQuill
            theme="snow"
            value={editorHtml}
            onChange={setEditorHtml}
            modules={modules}
            formats={formats}
            style={{ height: '300px' }}
            readOnly={isReadOnly}
          />
      <Button mt="2" colorScheme="blue" size="xs" display="none">
      </Button>
    </Box>
  );
};
 
 
const modules = {
  syntax: false, // Disable the default syntax module
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["blockquote", "code-block"],
    [{ align: [] }],
    ["link", "image"],
    ["clean"],
    [{ code_block: "" }],
 
  ],
};
 
const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "blockquote",
  "code-block",
  "align",
  "link",
  "image",
 
];
 
export default RichTextEditor;